import {defineAbilityConfig} from '../system/defineAbilityConfig';

/**
 * Used to view the comment speicific right sidebar.
 */
export const canViewCommentsRightSidebar = defineAbilityConfig({
  userTypes: {
    authorizedInDesigner: true,
    anonymousComment: true,
  },
  workflows: {
    comment: true,
  },
} as const);

// Defines whether a user can _eventually_ have access to comments and so
// we need to load them on site load, regardless of the workflow. It should
// be user exclusively on site load, for other cases, use `canAccessComments`.
export const canRequestLoadComments = defineAbilityConfig({
  userTypes: {
    authorizedInDesigner: true,
    anonymousComment: true,
  },
} as const);

// Defines whether the user can access the comments feature. This is usually related
// to whether users can view the Canvas (where comments are directed), hence removing
// workflows that do not have access to the Canvas (or where it is hidden).
// Component Canvas does not support comment mode, so this ability returns false
// when on a component page.
export const canAccessComments = defineAbilityConfig({
  userTypes: {
    authorizedInDesigner: true,
    anonymousComment: true,
  },
  workflows: {
    canvas: true,
    comment: true,
    preview: true,
    logicFlows: true,
    dynamicData: false,
    optimization: false,
    analyzeVisualView: true,
  },
  pageTypes: {
    componentCanvas: false,
  },
} as const);

export const canEnterCampaignCommentsFromHome = defineAbilityConfig({
  siteKinds: {campaign: true},
  userTypes: {
    authorizedInDesigner: true,
    anonymousComment: true,
  },
  workflows: {campaignsHome: true},
  pageTypes: {componentCanvas: false},
} as const);
